import React, { useRef, useState } from 'react';
import axios from 'axios';
import SaveModal from './modal/saveModal';
import Cookies from 'js-cookie';
import '../common/css/login.css';

function Login() {
    const idRef = useRef(null);
    const pwdRef = useRef(null);
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    const login = async () => {
        const data = { id: idRef.current.value, pw: pwdRef.current.value };

        try {
            if (!data.id) {
                setModalContent('아이디를 입력해주세요.');
                setModalAction(() => () => setSaveStatus(true));
                setSaveStatus(false);
                return;
            } else if (!data.pw) {
                setModalContent('비밀번호를 입력해주세요.');
                setModalAction(() => () => setSaveStatus(true));
                setSaveStatus(false);
                return;
            }
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.get(
                `${
                    isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/login`,
                {
                    params: { id: data.id, pw: data.pw },
                    withCredentials: true,
                },
            );

            if (response.status === 200) {
                Cookies.set('isLogin', true, { expires: 1 / 24 });
                window.location.href = '/';
            }
        } catch (err) {
            setModalContent(err?.response?.data?.message ?? '로그인중 오류가 발생했습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            login();
        }
    };
    
    return (
        <div className='member'>
            <div className='subp_h_wrap'>
                <div className='subp_h_list subp_h_home'>
                    <div>로그인</div>
                </div>
            </div>
            <div id='contents'>
                <div className='signUpFromWrap'>
                    <div className='page_hgroup'>
                        <h3 className='title'>로그인</h3>
                    </div>
                    <div className='confirm_form'>
                        <div className='login-inner'>
                            <table cellPadding='0' cellSpacing='0' className='login-table'>
                                {/* <colgroup>
                                    <col/>
                                    <col/>
                                </colgroup> */}
                                <tbody>
                                    <tr>
                                        <th>아이디</th>
                                        <td>
                                            <div className='boxed'>
                                                <input
                                                    type='text'
                                                    id='memId'
                                                    name='memId'
                                                    maxLength='12'
                                                    title='아이디'
                                                    isplaceholderinited='true'
                                                    ref={idRef}
                                                    onKeyDown={handleKeyDown}
                                                    style={{ marginBottom: '10px' }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>비밀번호</th>
                                        <td>
                                            <div className='boxed'>
                                                <input
                                                    type='password'
                                                    id='memPwd'
                                                    name='memPwd'
                                                    maxLength='12'
                                                    title='비밀번호'
                                                    autoComplete='off'
                                                    isplaceholderinited='true'
                                                    ref={pwdRef}
                                                    onKeyDown={handleKeyDown}
                                                    style={{ marginTop: '10px' }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='btn_wrap'>
                            <div className='fl_c'>
                                <a
                                    id='btnMemSubmit'
                                    className='btn46 red'
                                    onClick={(event) => {
                                        event.preventDefault();
                                        login();
                                    }}
                                >
                                    로그인하기
                                </a>
                            </div>
                        </div>
                        <p className='otherChoise'>
                            <a href='/idinquiry'>아이디 찾기</a>
                            <a>|</a>
                            <a href='/pwinquiry'>비밀번호 찾기</a>
                            <a>|</a>
                            <a href='/signup'>회원가입</a>
                        </p>
                    </div>
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default Login;
